import React from 'react';
import { Flex, Input, Typography } from 'antd';
import { FormikProps } from 'formik';

import { mainFormFields } from '../utils/fields';

const { Text } = Typography;

export const MainForm = ({
    formik,
    loading,
}: {
    formik: FormikProps<{ token: string }>;
    loading: boolean;
}): JSX.Element => {
    return (
        <>
            {mainFormFields.map(item => (
                <Flex gap={8} vertical key={item.name}>
                    {item.title && <Text>{item.title}</Text>}
                    <Input.Password
                        disabled={loading}
                        value={formik.values[item.name]}
                        onChange={e =>
                            formik.setFieldValue(item.name, e.target.value)
                        }
                        placeholder={item.placeholder}
                    />
                </Flex>
            ))}
        </>
    );
};
